import { render } from "./MorphToField.vue?vue&type=template&id=1ddbd00e"
import script from "./MorphToField.vue?vue&type=script&lang=js"
export * from "./MorphToField.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/vendor/laravel/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"MorphToField.vue"]])

export default __exports__